
import React, { useEffect, useState } from "react";
import axios from "axios";
import "../Home/AppHome.css";
import "../Admin/Admin.css";
import Headers from "./Headers";
import { useNavigate } from "react-router-dom";

const BASE_URL = "https://gym-invoice-back.onrender.com";

export default function PendingPayments() {
  const [members, setMembers] = useState([]);
  const [filteredMembers, setFilteredMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  const [filters, setFilters] = useState({
    dueDate: "",
    memberId: "",
    branchCode: "",
    phone: "",
  });

  const [selectedMessage, setSelectedMessage] = useState("");

  const navigate = useNavigate();

  const whatsappMessages = [
    "Hey! Missed you at the gym today 💪 Hope you're doing okay. Let’s get back to the routine — you’ve got this!",
    "Don’t worry about the days you missed. What matters is starting again. Come back strong! 🔥",
    "Your goals are still waiting for you. Let’s smash the next workout together! 💥",
    "Every break is temporary. What matters is your comeback. See you soon at the gym! 😊",
    "Consistency > Perfection. Even a light workout today is better than none. Let’s go! 👊",
    "You were making great progress. Don’t stop now — return stronger than before! 💪🔥",
    "Off days happen… but don’t let them slow your momentum. I believe in you! 🙌",
    "Your fitness journey didn’t stop. Come back today and keep moving forward! 🚀",
    "Strong decisions build strong bodies. Make today count — see you at the gym! 💯",
    "A small restart can lead to a big transformation. Let’s continue the journey! 💪✨",
  ];

  // Authentication check
  useEffect(() => {
    const role = sessionStorage.getItem("userRole");

    if (!role) {
      navigate("/");
    }
  }, [navigate]);

  // Fetch pending payment reminders
  useEffect(() => {
    fetchPendingMembers();
  }, []);

  const fetchPendingMembers = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${BASE_URL}/api/members/pending-payments`
      );

      console.log("Pending Payments API:", res.data);
      console.log("First member:", res.data[0]);
      console.log(
        "Branch codes:",
        res.data.map((m) => m.branchCode ?? m.BranchCode)
      );

      setMembers(res.data);
      setFilteredMembers(res.data);
    } catch (err) {
      console.error("Error fetching pending payments:", err);
    } finally {
      setLoading(false);
    }
  };

  // Format date
  const formatDate = (date) => {
    if (!date) return "-";

    const d = new Date(date);

    if (Number.isNaN(d.getTime())) return "-";

    const localDate = new Date(
      d.getTime() + d.getTimezoneOffset() * 60000
    );

    const dd = String(localDate.getDate()).padStart(2, "0");
    const mm = String(localDate.getMonth() + 1).padStart(2, "0");
    const yyyy = localDate.getFullYear();

    return `${dd}/${mm}/${yyyy}`;
  };

  // Filter members
  const handleFilter = () => {
    let results = [...members];

    const { dueDate, memberId, branchCode, phone } = filters;

    if (dueDate) {
      const selectedDate = new Date(dueDate);

      results = results.filter(
        (m) =>
          m.nextDueDate &&
          new Date(m.nextDueDate) <= selectedDate
      );
    }

    if (memberId.trim()) {
      results = results.filter((m) =>
        (m.memberId || "")
          .toLowerCase()
          .includes(memberId.trim().toLowerCase())
      );
    }

    // Branch filter
    if (branchCode) {
      results = results.filter((m) => {
        const memberBranch = (
          m.branchCode ||
          m.BranchCode ||
          ""
        ).toUpperCase();

        return memberBranch === branchCode.toUpperCase();
      });
    }

    if (phone.trim()) {
      results = results.filter((m) =>
        (m.mobile || "").includes(phone.trim())
      );
    }

    setFilteredMembers(results);
  };

  // Clear filters
  const clearFilters = () => {
    setFilters({
      dueDate: "",
      memberId: "",
      branchCode: "",
      phone: "",
    });

    setFilteredMembers(members);
  };

  // Send WhatsApp reminder
  const sendWhatsApp = (member) => {
    if (!selectedMessage) {
      alert("Please select a WhatsApp message!");
      return;
    }

    const message =
      `📢 *LIFE FITNESS PARTNER*\n\n` +
      `${selectedMessage}\n\n` +
      `👤 *Member:* ${member.name || ""}\n` +
      `🆔 *ID:* ${member.memberId || ""}\n` +
      `📞 Need help? Call: +94-761330825`;

    // Format Sri Lankan mobile number
    let phone = (member.mobile || "").replace(/\D/g, "");

    if (phone.startsWith("0")) {
      phone = "94" + phone.substring(1);
    } else if (!phone.startsWith("94") && phone) {
      phone = "94" + phone;
    }

    if (!phone) {
      alert("This member does not have a phone number.");
      return;
    }

    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="dashboard">
      <Headers />

      <div className="payment-container">
        <h2>📋 Reminders</h2>

        <p style={{ marginTop: "-5px", color: "#555" }}>
          👥 Total Members: <strong>{filteredMembers.length}</strong>
        </p>

        {/* Filters */}
        <div className="payment-card">
          <div className="filter-item">
            <label>Branch Code</label>

            <select
              className="duration-select"
              value={filters.branchCode}
              onChange={(e) =>
                setFilters({
                  ...filters,
                  branchCode: e.target.value,
                })
              }
            >
              <option value="">ALL BRANCHES</option>
              <option value="KB">KB - Kesbewa</option>
              <option value="WB">WB - Werahera</option>
            </select>
          </div>

          <input
            type="text"
            placeholder="Member ID"
            value={filters.memberId}
            onChange={(e) =>
              setFilters({
                ...filters,
                memberId: e.target.value,
              })
            }
          />

          <input
            type="text"
            placeholder="Phone"
            value={filters.phone}
            onChange={(e) =>
              setFilters({
                ...filters,
                phone: e.target.value,
              })
            }
          />

          <div className="filter-buttons">
            <button
              className="btn btn-primary"
              onClick={handleFilter}
            >
              Filter
            </button>

            <button
              className="btn btn-secondary"
              onClick={clearFilters}
            >
              Clear
            </button>
          </div>
        </div>

        {/* WhatsApp Message Selector */}
        <div
          className="payment-card"
          style={{ marginTop: "10px" }}
        >
          <label>Select WhatsApp Message</label>

          <select
            className="form-select"
            value={selectedMessage}
            onChange={(e) => setSelectedMessage(e.target.value)}
          >
            <option value="">-- Select Message --</option>

            {whatsappMessages.map((msg, i) => (
              <option key={i} value={msg}>
                Message {i + 1}
              </option>
            ))}
          </select>
        </div>

        {/* Members Table */}
        {loading ? (
          <p>Loading...</p>
        ) : filteredMembers.length === 0 ? (
          <p style={{ color: "green" }}>
            ✅ No pending payments
          </p>
        ) : (
          <table className="payment-table">
            <thead>
              <tr>
                <th>Branch Code</th>
                <th>Member ID</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Membership Type</th>
                <th>Last Payment</th>
                <th>Next Due Date</th>
                <th>Last Attendance Date</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {filteredMembers.map((m, i) => (
                <tr key={m._id || m.memberId || i}>
                  <td>{m.branchCode || m.BranchCode || "-"}</td>
                  <td>{m.memberId || "-"}</td>
                  <td>{m.name || "-"}</td>
                  <td>{m.mobile || "-"}</td>
                  <td>{m.membershipType || "-"}</td>
                  <td>{formatDate(m.lastPaymentDate)}</td>

                  <td
                    style={{
                      color: "red",
                      fontWeight: "bold",
                    }}
                  >
                    {formatDate(m.nextDueDate)}
                  </td>

                  <td>{formatDate(m.latestAttendanceDate)}</td>

                  <td>
                    <button
                      className="pay-button"
                      onClick={() => sendWhatsApp(m)}
                    >
                      📲 WhatsApp
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
